'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dAgent$002dView$0024$0024anon$002429 from "./presto.-Agent-View$$anon$29.js";
import * as $j_presto$002e$002dAgent$002dView$0024$002dLocal$002dPje$002dOffice$002dSign$002dHash$002dRequest$0024 from "./presto.-Agent-View$-Local-Pje-Office-Sign-Hash-Request$.js";
import * as $j_presto$002etypes$0024$002dSome$002dHash$0024 from "./presto.types$-Some-Hash$.js";
import * as $j_presto$002etypes$0024$002dU$002dR$002dL$0024 from "./presto.types$-U-R-L$.js";
var $p;
/** @constructor */
function $c_Lpresto_AgentView$$anon$28() {
  this.ayU = null;
  this.ayM = null;
  this.ayN = false;
  this.ayV = null;
  this.ayW = false;
  this.ayZ = null;
  this.ayS = null;
  this.ayT = false;
  this.ayO = null;
  this.ayP = false;
  this.ayQ = null;
  this.ayR = false;
  this.ayX = false;
  this.ayY = false;
  this.ayU = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.ayZ = "LocalPjeOfficeSignHashRequest";
}
export { $c_Lpresto_AgentView$$anon$28 as $c_Lpresto_AgentView$$anon$28 };
$p = $c_Lpresto_AgentView$$anon$28.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AgentView$$anon$28;
/** @constructor */
function $h_Lpresto_AgentView$$anon$28() {
}
export { $h_Lpresto_AgentView$$anon$28 as $h_Lpresto_AgentView$$anon$28 };
$h_Lpresto_AgentView$$anon$28.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.ayU;
});
$p.M = (function() {
  if ((!this.ayN)) {
    this.ayM = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.ayN = true;
  }
  return this.ayM;
});
$p.O = (function() {
  if ((!this.ayW)) {
    this.ayV = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.ayW = true;
  }
  return this.ayV;
});
$p.D = (function() {
  return this.ayZ;
});
$p.t = (function() {
  if ((!this.ayT)) {
    this.ayS = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("origin", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("algo", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("hashes", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.ayT = true;
  }
  return this.ayS;
});
$p.N = (function() {
  if ((!this.ayP)) {
    this.ayO = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dU$002dR$002dL$0024.$m_Lpresto_types$URL$().fi(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a9, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$44($j_presto$002etypes$0024$002dSome$002dHash$0024.$m_Lpresto_types$SomeHash$().a34())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.ayP = true;
  }
  return this.ayO;
});
$p.Q = (function() {
  if ((!this.ayR)) {
    this.ayQ = new $j_presto$002e$002dAgent$002dView$0024$0024anon$002429.$c_Lpresto_AgentView$$anon$29();
    this.ayR = true;
  }
  return this.ayQ;
});
$p.v = (function() {
  if ((!this.ayY)) {
    this.ayX = false;
    this.ayY = true;
  }
  return this.ayX;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee196) => ((p) => \u03b4scrutinee196.cGR(p)))($j_presto$002e$002dAgent$002dView$0024$002dLocal$002dPje$002dOffice$002dSign$002dHash$002dRequest$0024.$m_Lpresto_AgentView$LocalPjeOfficeSignHashRequest$())));
});
var $d_Lpresto_AgentView$$anon$28 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AgentView$$anon$28, "presto.AgentView$$anon$28", ({
  DX: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_AgentView$$anon$28 as $d_Lpresto_AgentView$$anon$28 };
//# sourceMappingURL=presto.-Agent-View$$anon$28.js.map
